module.exports = __webpack_public_path__ + "effa1c2835223da96da29c03f7eafa91.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/landing/preview_section/assets/tv.png
// module id = ./src/components/landing/preview_section/assets/tv.png
// module chunks = index